import React, { useMemo } from 'react';
import { CardSize, type GoodToKnowProps } from './types';
import Layout from './components/Layout/Layout';
import type { ModalAPI } from './components/Modal/types';
import Modal from './components/Modal/Modal';
import { getSectionsInOrder, type Section } from './sections';
import { useTrackingActions } from './context/TrackingContext/TrackingContext';

import styles from './GoodToKnow.module.scss';

const getModalContent = (config: Section[], selectedKey: string | null) => {
  let ModalContentToShow: React.JSX.Element[] = Object.values(config).map(({ key, GeneralView }) => (
    <GeneralView key={key} />
  ));

  if (selectedKey) {
    const section = config.find(({ key }) => key === selectedKey) || {
      SingleView: () => null,
    };
    ModalContentToShow = [<section.SingleView key="singleSection" />];
  }

  return ModalContentToShow;
};

export const GoodToKnow: React.FC<GoodToKnowProps> = (props) => {
  const [selectedKey, setSelectedKey] = React.useState<string | null>(null);
  const modalRef = React.useRef<ModalAPI>(null);

  const { onReadMoreClick, onViewAllClick } = useTrackingActions();

  const config = useMemo(() => getSectionsInOrder(props), [props.highlights, props.faqs, props.refundPolicy]);

  const ModalContentToShow = getModalContent(config, selectedKey);

  const handleClick = (key: string | null = null) => {
    setSelectedKey(key);
    modalRef.current?.show();
  };

  const handleReadMoreClick = (key: string) => {
    onReadMoreClick(key);
    handleClick(key);
  };

  const handleViewAllClick = () => {
    onViewAllClick();
    handleClick();
  };

  const modalContent = (
    <Modal onClose={() => {}} ref={modalRef}>
      {ModalContentToShow}
    </Modal>
  );

  return (
    <div className={styles.goodToKnow}>
      <Layout onViewAllClick={handleViewAllClick} showViewAll={props.showViewAll}>
        {config.map(({ key, CardView }) => (
          <CardView
            key={key}
            onReadMoreClick={() => {
              handleReadMoreClick(key);
            }}
            size={props.cardSize || CardSize.CONTAINED}
          />
        ))}
      </Layout>
      {modalContent}
    </div>
  );
};
